import { useEffect, useState } from 'react';
import { MEDIA_DISABLED } from './client';
import { pollMediaCapabilities } from './capabilityPolling';

export default function useMediaCapabilities(userId) {
  const [state, setState] = useState({ userId: null, caps: MEDIA_DISABLED });
  useEffect(() => {
    if (!userId) return undefined;
    const controller = new AbortController();
    const refresh = pollMediaCapabilities(controller.signal, caps => setState({ userId, caps }));
    refresh();
    const timer = setInterval(refresh, 30000);
    window.addEventListener('focus', refresh);
    return () => { controller.abort(); clearInterval(timer); window.removeEventListener('focus', refresh); };
  }, [userId]);
  return state.userId === userId ? state.caps : MEDIA_DISABLED;
}
